<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="fa fa-database"></i></span>
    </div>
    <input class="form-control" v-model="editedCoins" :disabled="userLock" :class="error ? 'is-invalid' : ''" :readonly="allowed" type="number">
    <span class="input-group-append"><button class="btn btn-primary" :disabled="servers[server].readonly || userLock || error != null || allowed || !hasChanged" @click="changeCoins" type="button">Change</button></span>
    <div class="invalid-feedback">{{error}}</div>

  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import Servers from '../../../_servers'

  export default {
    name: 'Coins',
    props: ['coins', 'server', 'userid', 'allowed'],
    data () {
      return {
        error: null,
        editedCoins: this.coins,
        servers: Servers
      }
    },
    computed: {
      ...mapGetters([
        'userLock'
      ]),
      hasChanged () {
        return Number(this.editedCoins) !== Number(this.coins)
      }
    },
    watch: {
      coins (value) {
        this.editedCoins = value
      },
      userid () {
        this.editedCoins = this.coins
      },
      server () {
        this.editedCoins = this.coins
      }
    },
    methods: {
      validateEmail (email) {
        let re = /\S+@\S+\.\S+/
        return re.test(String(email).toLowerCase())
      },
      changeCoins () {
        if (!this.hasChanged) {
          return
        }
        this.emit('changeCoins', {
          id: this.userid,
          value: Number(this.editedCoins),
          server: this.server
        })
        this.setLock(true)
      },
      ...mapActions(['setLock'])
    }
  }
</script>
